import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { Navigate, useNavigate } from "react-router-dom";
import Input from "./Form/Input";
import SubmitButton from "./Form/SubmitButton";

import { register as registerUser } from "../app/actions/auth";

const formFields = [
  {
    label: "Username",
    type: "text",
    name: "username",
  },
  {
    label: "Password",
    type: "password",
    name: "password",
  },
  {
    label: "Email",
    type: "email",
    name: "email",
  },
  {
    label: "First Name",
    type: "text",
    name: "first_name",
  },
  {
    label: "Last Name",
    type: "text",
    name: "last_name",
  },
  {
    label: "Job Title",
    type: "text",
    name: "job_title",
  },
];

const Register = () => {
  const [loading, setLoading] = useState(false);
  const { isLoggedIn } = useSelector((state) => state.auth);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const dispatch = useDispatch();
  let navigate = useNavigate();

  const onSubmit = (data) => {
    // console.log("onSubmit");
    setLoading(true);
    // console.log(data);

    dispatch(registerUser(data))
      .then(() => {
        navigate("/login");
        window.location.reload();
      })
      .catch(() => {
        setLoading(false);
      });
  };

  if (isLoggedIn) {
    return <Navigate to="/dashboard" />;
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      {formFields.map((field) => (
        <div>
          <Input
            label={field.label}
            name={field.name}
            type={field.type}
            register={register}
            options={{ required: true }}
          />
          {errors[field.name] && <span>This field is required</span>}
        </div>
      ))}

      <SubmitButton loading={loading} />
    </form>
  );
};

export default Register;
